export * from '@sentry/browser';
export { init } from './sdk.js';
export { vueRouterInstrumentation } from './router.js';
export { browserTracingIntegration } from './browserTracingIntegration.js';
export { attachErrorHandler } from './errorhandler.js';
export { createTracingMixins } from './tracing.js';
export { VueIntegration, vueIntegration } from './integration.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@sentry/vue/esm/index.js